import { Box, Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  Wrapper: styled(Flex, {
    flexDirection: 'column',
  }),

  Component: styled(Box, {
    '&[data-alternate="true"]': {
      background: '$backgroundSecondary',
    },
  }),
};

export const ComponentInnerWrapper = styled('div', {
  padding: '$10 0',
});

export default styles;
